import { IHabitatServiceTypeProp, IObservationServiceObj } from "../../../shared/apiServices/IApiInterfaces";

export const convertDateFormat = (originalDate: string)  => {
    // Parse the original date string
    const dateParts: number[] = originalDate.split('-').map(Number);
    const parsedDate: Date = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
  
    const formattedDate = `${parsedDate.getMonth() + 1}/${parsedDate.getDate()}/${parsedDate.getFullYear()}`;
  
    return formattedDate;
  }

  export const typePropGetter = (name: string, data?: IHabitatServiceTypeProp[], type = '') => {
    const value = data?.find(
      (prop: IHabitatServiceTypeProp) => prop.name === name
    )?.value;
    if (value && type === 'date') {
        return convertDateFormat(value);
    }
    return value ? parseInt(value, 10) : '';
  };

  export const isObservationOwner = (observation: IObservationServiceObj, userEmail: string | undefined): boolean => observation.observedBy === userEmail;
